export default __webpack_public_path__ + "static/media/mon_64.30fd6139.png";